var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepScanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#2B2826"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.19999,
    y: -4.19999,
    width: 46.4,
    height: 46.4
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.4px)",
      clipPath: "url(#bgblur_0_10891_67328_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10891_67328)",
    "data-figma-bg-blur-radius": 12.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 9C10.7909 9 9 10.7909 9 13V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V13C11 11.8954 11.8954 11 13 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H13Z",
    fill: "url(#paint0_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 9C22.4477 9 22 9.44772 22 10C22 10.5523 22.4477 11 23 11H25C26.1046 11 27 11.8954 27 13V15C27 15.5523 27.4477 16 28 16C28.5523 16 29 15.5523 29 15V13C29 10.7909 27.2091 9 25 9H23Z",
    fill: "url(#paint1_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23C11 22.4477 10.5523 22 10 22C9.44772 22 9 22.4477 9 23V25C9 27.2091 10.7909 29 13 29H15C15.5523 29 16 28.5523 16 28C16 27.4477 15.5523 27 15 27H13C11.8954 27 11 26.1046 11 25V23Z",
    fill: "url(#paint2_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 23C29 22.4477 28.5523 22 28 22C27.4477 22 27 22.4477 27 23V25C27 26.1046 26.1046 27 25 27H23C22.4477 27 22 27.4477 22 28C22 28.5523 22.4477 29 23 29H25C27.2091 29 29 27.2091 29 25V23Z",
    fill: "url(#paint3_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 13.4477 13.4477 13 14 13H17C17.5523 13 18 13.4477 18 14V17C18 17.5523 17.5523 18 17 18H14C13.4477 18 13 17.5523 13 17V14Z",
    fill: "url(#paint4_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14C20 13.4477 20.4477 13 21 13H24C24.5523 13 25 13.4477 25 14V17C25 17.5523 24.5523 18 24 18C23.4477 18 23 17.5523 23 17V15H21C20.4477 15 20 14.5523 20 14Z",
    fill: "url(#paint5_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.99C22 16.4377 21.5523 15.99 21 15.99C20.4477 15.99 20 16.4377 20 16.99V17C20 17.5523 20.4477 18 21 18C21.5523 18 22 17.5523 22 17V16.99Z",
    fill: "url(#paint6_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21C13 20.4477 13.4477 20 14 20H17C17.5523 20 18 20.4477 18 21C18 21.5523 17.5523 22 17 22H15V22.5C15 23.0523 14.5523 23.5 14 23.5C13.4477 23.5 13 23.0523 13 22.5V21Z",
    fill: "url(#paint7_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 20C20.4477 20 20 20.4477 20 21V24C20 24.5523 20.4477 25 21 25H24C24.5523 25 25 24.5523 25 24V21C25 20.4477 24.5523 20 24 20H21Z",
    fill: "url(#paint8_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99 24C15.99 23.4477 16.4377 23 16.99 23H17C17.5523 23 18 23.4477 18 24C18 24.5523 17.5523 25 17 25H16.99C16.4377 25 15.99 24.5523 15.99 24Z",
    fill: "url(#paint9_linear_10891_67328)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21.7998C10.6627 21.7998 11.2002 22.3373 11.2002 23V25C11.2002 25.9941 12.0059 26.7998 13 26.7998H15C15.6627 26.7998 16.2002 27.3373 16.2002 28C16.2002 28.6627 15.6627 29.2002 15 29.2002H13C10.6804 29.2002 8.7998 27.3196 8.7998 25V23C8.7998 22.3373 9.33726 21.7998 10 21.7998ZM28 21.7998C28.6627 21.7998 29.2002 22.3373 29.2002 23V25C29.2002 27.3196 27.3196 29.2002 25 29.2002H23C22.3373 29.2002 21.7998 28.6627 21.7998 28C21.7998 27.3373 22.3373 26.7998 23 26.7998H25C25.9941 26.7998 26.7998 25.9941 26.7998 25V23C26.7998 22.3373 27.3373 21.7998 28 21.7998ZM17 22.7998C17.6627 22.7998 18.2002 23.3373 18.2002 24C18.2002 24.6627 17.6627 25.2002 17 25.2002H16.9902C16.3275 25.2002 15.79 24.6627 15.79 24C15.79 23.3373 16.3275 22.7998 16.9902 22.7998H17ZM24 19.7998C24.6627 19.7998 25.2002 20.3373 25.2002 21V24C25.2002 24.6627 24.6627 25.2002 24 25.2002H21C20.3373 25.2002 19.7998 24.6627 19.7998 24V21C19.7998 20.3373 20.3373 19.7998 21 19.7998H24ZM17 19.7998C17.6627 19.7998 18.2002 20.3373 18.2002 21C18.2002 21.6627 17.6627 22.2002 17 22.2002H15.2002V22.5C15.2002 23.1627 14.6627 23.7002 14 23.7002C13.3373 23.7002 12.7998 23.1627 12.7998 22.5V21C12.7998 20.3373 13.3373 19.7998 14 19.7998H17ZM17 12.7998C17.6627 12.7998 18.2002 13.3373 18.2002 14V17C18.2002 17.6627 17.6627 18.2002 17 18.2002H14C13.3373 18.2002 12.7998 17.6627 12.7998 17V14C12.7998 13.3373 13.3373 12.7998 14 12.7998H17ZM21 15.79C21.6627 15.79 22.2002 16.3275 22.2002 16.9902V17C22.2002 17.6627 21.6627 18.2002 21 18.2002C20.3373 18.2002 19.7998 17.6627 19.7998 17V16.9902C19.7998 16.3275 20.3373 15.79 21 15.79ZM24 12.7998C24.6627 12.7998 25.2002 13.3373 25.2002 14V17C25.2002 17.6627 24.6627 18.2002 24 18.2002C23.3373 18.2002 22.7998 17.6627 22.7998 17V15.2002H21C20.3373 15.2002 19.7998 14.6627 19.7998 14C19.7998 13.3373 20.3373 12.7998 21 12.7998H24ZM15 8.7998C15.6627 8.7998 16.2002 9.33726 16.2002 10C16.2002 10.6627 15.6627 11.2002 15 11.2002H13C12.0059 11.2002 11.2002 12.0059 11.2002 13V15C11.2002 15.6627 10.6627 16.2002 10 16.2002C9.33726 16.2002 8.7998 15.6627 8.7998 15V13C8.7998 10.6804 10.6804 8.7998 13 8.7998H15ZM25 8.7998C27.3196 8.7998 29.2002 10.6804 29.2002 13V15C29.2002 15.6627 28.6627 16.2002 28 16.2002C27.3373 16.2002 26.7998 15.6627 26.7998 15V13C26.7998 12.0059 25.9941 11.2002 25 11.2002H23C22.3373 11.2002 21.7998 10.6627 21.7998 10C21.7998 9.33726 22.3373 8.7998 23 8.7998H25Z",
    stroke: "#C58000",
    strokeOpacity: 0.48,
    strokeWidth: 0.4,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10891_67328",
    x: -4.19999,
    y: -4.19999,
    width: 46.4,
    height: 46.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.899346 0 0 0 0 0.713726 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10891_67328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10891_67328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_10891_67328_clip_path",
    transform: "translate(4.19999 4.19999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 9C10.7909 9 9 10.7909 9 13V15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V13C11 11.8954 11.8954 11 13 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 9C22.4477 9 22 9.44772 22 10C22 10.5523 22.4477 11 23 11H25C26.1046 11 27 11.8954 27 13V15C27 15.5523 27.4477 16 28 16C28.5523 16 29 15.5523 29 15V13C29 10.7909 27.2091 9 25 9H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23C11 22.4477 10.5523 22 10 22C9.44772 22 9 22.4477 9 23V25C9 27.2091 10.7909 29 13 29H15C15.5523 29 16 28.5523 16 28C16 27.4477 15.5523 27 15 27H13C11.8954 27 11 26.1046 11 25V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 23C29 22.4477 28.5523 22 28 22C27.4477 22 27 22.4477 27 23V25C27 26.1046 26.1046 27 25 27H23C22.4477 27 22 27.4477 22 28C22 28.5523 22.4477 29 23 29H25C27.2091 29 29 27.2091 29 25V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 13.4477 13.4477 13 14 13H17C17.5523 13 18 13.4477 18 14V17C18 17.5523 17.5523 18 17 18H14C13.4477 18 13 17.5523 13 17V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14C20 13.4477 20.4477 13 21 13H24C24.5523 13 25 13.4477 25 14V17C25 17.5523 24.5523 18 24 18C23.4477 18 23 17.5523 23 17V15H21C20.4477 15 20 14.5523 20 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.99C22 16.4377 21.5523 15.99 21 15.99C20.4477 15.99 20 16.4377 20 16.99V17C20 17.5523 20.4477 18 21 18C21.5523 18 22 17.5523 22 17V16.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21C13 20.4477 13.4477 20 14 20H17C17.5523 20 18 20.4477 18 21C18 21.5523 17.5523 22 17 22H15V22.5C15 23.0523 14.5523 23.5 14 23.5C13.4477 23.5 13 23.0523 13 22.5V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 20C20.4477 20 20 20.4477 20 21V24C20 24.5523 20.4477 25 21 25H24C24.5523 25 25 24.5523 25 24V21C25 20.4477 24.5523 20 24 20H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99 24C15.99 23.4477 16.4377 23 16.99 23H17C17.5523 23 18 23.4477 18 24C18 24.5523 17.5523 25 17 25H16.99C16.4377 25 15.99 24.5523 15.99 24Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10891_67328",
    x1: 19,
    y1: 21.0042,
    x2: 19,
    y2: 26.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFBAA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepScanner);
export default __webpack_public_path__ + "static/media/stepScanner.018e2c38aa3ed8d6a44bb105fa702a6a.svg";
export { ForwardRef as ReactComponent };